<template>
  <div class="container-fluid">
    <span class="resize-loading" v-if="!syncLog">
      <span class="loader"></span>
    </span>
    <div v-if="syncLog" class="elite-tabs-wrapper">
      <tabs
        fill
        class="flex-column flex-md-row"
        tabNavWrapperClasses="nav-wrapper"
        tabNavClasses="nav elite-tabs"
        value="syncLog"
      >
        <tab-pane title="syncLog" id="1" :active="true">
          <span slot="title">
            <i class="ni ni-cloud-upload-96"></i>
            {{ $t("COMMON.GLOBAL") }}
          </span>
          <sync-log-view-global
            :syncLog="syncLog"
            @onContractUpdated="get"
            @relunchSync="relunchSync"
            @toggleAttempts="toggleAttempts"
            @deleteSyncLog="deleteSyncLog"
          />
        </tab-pane>

        <tab-pane
          title="files"
          id="998"
          v-if="$currentUserCan($permissions.PERM_VIEW_ANY_FILES)"
        >
          <span slot="title">
            <i class="ni ni-folder-17"></i>
            {{ $t("COMMON.FILES") }}
          </span>
          <div class="elite-tabs-wrapper-content">
            <list-file-component :object="syncLog" />
          </div>
        </tab-pane>

        <tab-pane
          title="logs"
          id="999"
          v-if="$currentUserCan($permissions.PERM_VIEW_ANY_LOGS)"
        >
          <span slot="title">
            <i class="fa fa-file"></i>
            {{ $t("COMMON.LOGS") }}
          </span>
          <sync-log-view-logs :syncLog="syncLog" />
        </tab-pane>
      </tabs>
    </div>
  </div>
</template>

<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  Button,
} from "element-ui";
import { Tabs, TabPane } from "@/components";
import ListFileComponent from "@/components/File/ListFileComponent.vue";
import SyncLogViewLogs from "../partials/SyncLogViewLogs.vue";
import SyncLogViewGlobal from "../partials/SyncLogViewGlobal.vue";

export default {
  layout: "DashboardLayout",

  components: {
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    Tabs,
    TabPane,
    SyncLogViewLogs,
    ListFileComponent,
    SyncLogViewGlobal,
  },

  mixins: [],

  props: {
    syncLogId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      syncLog: null,
    };
  },

  computed: {},

  watch: {},

  created() {
    this.get();
  },

  methods: {
    async get() {
      try {
        await this.$store.dispatch("syncLogs/get", this.syncLogId);
        this.syncLog = this.$store.getters["syncLogs/syncLog"];
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },
    relunchSync() {
      this.$emit("relunchSync", this.syncLog);
    },
    toggleAttempts() {
      this.$emit("toggleAttempts", this.syncLog);
    },
    deleteSyncLog() {
      this.$emit("deleteSyncLog", this.signature);
    },
  },
};
</script>
